module.exports = __webpack_public_path__ + "static/media/prep-1.f2f92eb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prep-1.jpg
// module id = 161
// module chunks = 0